import axios from 'axios';
import Alert from '@mui/lab/Alert';
import Grid from '@mui/material/Grid';
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router';
import Loader from 'react-loader-spinner';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';

import './style.scss';
import logo from '../../images/lhcf_logo.jpeg';

const baseUrl = process.env.REACT_APP_BASE_URL;

const LoginPage = (props) => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [specificError, setSpecificError] = useState('');
  const [credentials, setCredentials] = useState({
    email: '',
    password: '',
  });
  const [snackbarState, setSnackbarState] = useState({
    warningOpen: false,
    errorOpen: false,
    specificErrorOpen: false,
    vertical: 'center',
    horizontal: 'center',
  });

  const { errorOpen, specificErrorOpen, vertical, horizontal } = snackbarState;

  const handleClose = () => {
    setSnackbarState({
      ...snackbarState,
      errorOpen: false,
      successOpen: false,
      specificErrorOpen: false,
    });
  };

  const handleInputChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmission = (e) => {
    e.preventDefault();

    setLoading(true);

    axios
      .post(`${baseUrl}/auth/signin`, credentials)
      .then(
        ({
          data: {
            data: { token },
          },
        }) => {
          setLoading(false);
          localStorage.setItem('lhcfToken', token);
          history.push('/dashboard');
        }
      )
      .catch((err) => {
        console.log(err.response);

        if (err.response.data.message) {
          setSpecificError(err.response.data.message);
          setSnackbarState({ ...snackbarState, specificErrorOpen: true });
        } else {
          setSnackbarState({ ...snackbarState, errorOpen: true });
        }

        setLoading(false);
      });
  };

  return (
    <Grid className="loginWrapper">
      <Snackbar
        open={errorOpen}
        autoHideDuration={10000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
          Could not log you in. Try again.
        </Alert>
      </Snackbar>
      <Snackbar
        open={specificErrorOpen}
        autoHideDuration={10000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
          {specificError}
        </Alert>
      </Snackbar>
      <Grid className="loginForm">
        <div className="shape-img" onClick={() => history.push('/')}>
          <img src={logo} alt="" />
        </div>
        {/* <br />
        <h2 style={{ color: '#000' }}>ADMIN DASHBOARD</h2>
        <p>Login to the Dashboard</p> */}
        <form onSubmit={handleSubmission}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                id="filled-basic-email"
                label="Email"
                name="email"
                variant="filled"
                fullWidth
                value={credentials.email}
                onChange={handleInputChange}
                type="email"
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="filled-basic-password"
                label="Password"
                name="password"
                variant="filled"
                fullWidth
                value={credentials.password}
                onChange={handleInputChange}
                type="password"
                required
              />
            </Grid>
            <Grid item xs={12}>
              <Grid className="formFooter">
                {loading ? (
                  <Button variant="contained" color="error" disabled fullWidth>
                    <Loader
                      type="Oval"
                      color="#d90404"
                      height={30}
                      width={50}
                    />
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    fullWidth
                    color="error"
                    type="submit"
                  >
                    Login to the Dashboard
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
};

export default LoginPage;
